import React, { Component } from 'react';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class HurViAnvanderCookies extends Component {
    static displayName = HurViAnvanderCookies.name;
        
    constructor(props) {
        super(props);
        this.state = {};        
    }

    componentDidMount() {
        document.title = "Eurostar Biografer - Cookies";
    }
    
    render() {
        
        const cookieValue = cookies.get('eurostarcookievalues');
        const cityCode = cookieValue === null || cookieValue === undefined ? 11 : cookieValue.cityCode;
        
        return (
            
          <div> 
            <div className="page-header">

                <div className="row">
                    <div className="col-md-12 noPadding">
                            <h1>Hur vi anv&auml;nder Cookies</h1>
                            Denna hemsida anv&#228;nder sig av cookies f&#246;r att lagra inskrivet telefonnummer samt vald stad.
                    </div>
                </div>
            </div>
          </div>
        );
    }
}
